// import Home from "@/views/Home"

const tabbar = [
	{
		path: '/home',
		name: 'Home',
		component: () => import('@/views/Home'),
		meta: { name: '首页', tabShow: true, keepAlive: true },
		icon: {
			active: require('@/assets/Tabbar/achome.svg'),
			inactive: require('@/assets/Tabbar/home.svg'),
		},
	},
	{
		path: '/category',
		name: 'Category',
		component: () => import('@/views/category'),
		meta: { name: '分类', tabShow: true, keepAlive: true },
		icon: {
			active: require('@/assets/Tabbar/accategory.svg'),
			inactive: require('@/assets/Tabbar/category.svg'),
		},
	},
	// {
	//   path: '/gift',
	//   name: 'gift',
	//   component: () => import('@/views/gift'),
	//   meta: { name: '赠礼', tabShow: true },
	//   icon: {
	//     active: require("@/assets/Tabbar/acgift.svg"),
	//     inactive: require("@/assets/Tabbar/gift.svg")
	//   }
	// },
	{
		path: '/car',
		name: 'Car',
		component: () => import('@/views/car'),
		meta: { name: '购物车', tabShow: true, keepAlive: true },
		icon: {
			active: require('@/assets/Tabbar/accar.svg'),
			inactive: require('@/assets/Tabbar/car.svg'),
		},
	},
	{
		path: '/my',
		name: 'My',
		component: () => import('@/views/my'),
		meta: { name: '我的', tabShow: true },
		icon: {
			active: require('@/assets/Tabbar/acmy.svg'),
			inactive: require('@/assets/Tabbar/my.svg'),
		},
	},
];

export default tabbar;
